import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MdCloudOff } from 'react-icons/md';
import { healthCheck } from '../services/api';

const ConnectionStatus = () => {
  const [isConnected, setIsConnected] = useState<boolean | null>(null);
  const [showStatus, setShowStatus] = useState(false);

  useEffect(() => {
    const checkConnection = async () => {
      const connected = await healthCheck();
      setIsConnected(connected);
      
      // Show status notification if disconnected
      if (!connected) {
        setShowStatus(true);
        // Auto-hide after 5 seconds
        setTimeout(() => setShowStatus(false), 5000);
      }
    };

    // Check on mount
    checkConnection();

    // Check periodically (every 30 seconds)
    const interval = setInterval(checkConnection, 30000);

    return () => clearInterval(interval);
  }, []);

  // Don't show anything if connected
  if (isConnected) {
    return null;
  }

  return (
    <AnimatePresence>
      {showStatus && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="fixed top-20 right-4 z-50 bg-red-500 text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-2 max-w-sm"
        >
          <MdCloudOff className="w-5 h-5 flex-shrink-0" />
          <div className="flex-1">
            <p className="font-semibold text-sm">Backend Disconnected</p>
            <p className="text-xs opacity-90">
              Make sure the backend server is running on{' '}
              {import.meta.env.VITE_API_URL || 'http://localhost:5000'}
            </p>
          </div>
          <button
            onClick={() => setShowStatus(false)}
            className="text-white hover:bg-red-600 rounded p-1 transition-colors"
          >
            ✕
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ConnectionStatus;
